<template>
  <v-autocomplete
    v-model="valueModel"
    :label="label"
    :items="parkOptions"
    :loading="loading"
    clearable
    @change="$emit('change')"
  >
    <template v-slot:append>
      <slot name="append"/>
    </template>
  </v-autocomplete>
</template>

<script>
  import client from '@/client'

  export default {
    props: ['value', 'label'],
    data: () => ({
      loading: false,
      parkOptions: []
    }),
    computed: {
      valueModel: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('input', value)
        }
      }
    },
    created () {
      this.loading = true
      client.getParkList()
        .then(results => {
          this.parkOptions = results
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
</script>